function LoginIcon() {
  const size = 56;
  const r = size * 0.19;
  const offset = (size - 2 * r * Math.cos(Math.PI / 8) - 4) / 2;

  function oct(cx: number, cy: number, radius: number) {
    return Array.from({ length: 8 }, (_, i) => {
      const a = (i * Math.PI) / 4 + Math.PI / 8;
      return `${(cx + radius * Math.cos(a)).toFixed(2)},${(cy + radius * Math.sin(a)).toFixed(2)}`;
    }).join(' ');
  }

  const cx1 = offset;
  const cy1 = offset;
  const cx2 = size - offset;
  const cy2 = offset;
  const cx3 = offset;
  const cy3 = size - offset;
  const cx4 = size - offset;
  const cy4 = size - offset;

  return (
    <div
      className="flex items-center justify-center rounded-2xl"
      style={{
        width: size + 16,
        height: size + 16,
        background: 'rgba(15,23,41,0.8)',
        boxShadow: '0 0 0 1px rgba(122,204,237,0.25), 0 0 60px -10px rgba(0,168,220,0.35)',
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <polygon points={oct(cx1, cy1, r)} fill="#E2E8F0" stroke="#2563EB" strokeWidth={2.5} />
        <polygon points={oct(cx2, cy2, r)} fill="#FCD34D" stroke="#B45309" strokeWidth={2.5} />
        <polygon points={oct(cx3, cy3, r)} fill="#FCA5A5" stroke="#991B1B" strokeWidth={2.5} />
        <polygon points={oct(cx4, cy4, r)} fill="#E2E8F0" stroke="#64748B" strokeWidth={2.5} />
      </svg>
    </div>
  );
}

export function LoginPage() {
  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="surface-glass rise-in w-full max-w-md p-10 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.8)]">
        <div className="mb-8 flex items-center justify-center">
          <LoginIcon />
        </div>

        <h1
          className="mb-2 text-center text-2xl font-semibold text-slate-100"
          style={{ letterSpacing: '-0.02em' }}
        >
          Command Floor
        </h1>
        <p className="mb-10 text-center text-sm text-slate-400">
          Pyek Group · portfolio management
        </p>

        <a
          href="/auth/login"
          className="btn-aurora block w-full px-4 py-3 text-center text-sm font-medium"
        >
          Sign in with Microsoft
        </a>

        <p className="mt-8 text-center text-xs text-slate-500">
          Authentication via your Pyek M365 account.
        </p>
      </div>
    </div>
  );
}
